import ko from 'knockout';
import moment from 'moment';
import $ from 'jquery';

export class QuotationConstants {

    //ItemType
    public static readonly TRANSLATIONS = 'Vertaling';
    public static readonly TRANSLATION_ENUM_INDEX = 0;

    public static readonly SUBTITLES = 'Ondertiteling';
    public static readonly SUBTITLES_ENUM_INDEX = 1;

    public static readonly VOICEOVERS = 'Voice-over';
    public static readonly VOICEOVERS_ENUM_INDEX = 2;

    //Currency
    public static readonly EURO = '€';
    public static readonly EURO_ENUM_INDEX = 0;

    public static readonly GBP = '£';
    public static readonly GBP_ENUM_INDEX = 1;

    public static readonly USD = '$';
    public static readonly USD_ENUM_INDEX = 2;

}

export class Language {
    label: string;
    value: string;
}

export class Deliverable {
    label: string;
    id: string;
    type: number;

    constructor(label: string, id: string, type: number) {
        this.label = label;
        this.id = id;
        this.type = type;
    }
}

export class Currency {
    label: string;
    value: number;
}

export class QuotationDataRetrieval {
    public static async allLanguages() {
        const response = await fetch('/Language/All', { credentials: 'include' });
        const json = await response.json();
        return json;
    }

    public static async allDeliverables() {
        const response = await fetch('/Deliverable/All', { credentials: 'include' });
        const json = await response.json();
        return json;
    }

    public static allCurrencies(): Currency[] {
        return [
            { label: QuotationConstants.EURO, value: QuotationConstants.EURO_ENUM_INDEX },
            { label: QuotationConstants.GBP, value: QuotationConstants.GBP_ENUM_INDEX },
            { label: QuotationConstants.USD, value: QuotationConstants.USD_ENUM_INDEX }
        ];
    }
}

export class AddAssignmentModel {
    from: KnockoutObservableArray<Language>;
    to: KnockoutObservableArray<Language>;
    startDate: KnockoutObservable<moment.Moment>;
    endDate: KnockoutObservable<moment.Moment>;
    type: KnockoutObservable<string>;
    index: KnockoutObservable<number>;
    leadTime: KnockoutObservable<number>;
    deliverables: KnockoutObservableArray<Deliverable>;
    selectedDeliverable: KnockoutObservable<Deliverable>;
    typeDeliverables: KnockoutComputed<Deliverable[]>;
    deliverableAmount: KnockoutObservable<number>;

    languages: KnockoutObservableArray<any>;
    constructor(type: string, index: number, globalLanguages: any[]) {
        let defaultEndTime = new Date();
        defaultEndTime.setHours(17);
        defaultEndTime.setMinutes(0);
        defaultEndTime.setSeconds(0);

        this.type = ko.observable<string>(type);
        this.index = ko.observable<number>(index);
        this.leadTime = ko.observable<number>(0);

        this.from = ko.observableArray<Language>();
        this.to = ko.observableArray<Language>();
        this.startDate = ko.observable<moment.Moment>(moment());

        this.endDate = ko.observable<moment.Moment>(moment(defaultEndTime));
        this.languages = ko.observableArray<any>(globalLanguages);
        this.deliverables = ko.observableArray<Deliverable>();
        this.selectedDeliverable = ko.observable<Deliverable>();
        this.deliverableAmount = ko.observable<number>(1);
        this.typeDeliverables = ko.pureComputed(() => {
            let myType = this.type() === QuotationConstants.SUBTITLES
                ? QuotationConstants.SUBTITLES_ENUM_INDEX
                : this.type() === QuotationConstants.TRANSLATIONS
                    ? QuotationConstants.TRANSLATION_ENUM_INDEX
                    : QuotationConstants.VOICEOVERS_ENUM_INDEX;

            return this.deliverables().filter((d) => { return d.type === myType });
        }, this);
        QuotationDataRetrieval.allDeliverables().then((d) => {
            this.deliverables(d);
        });
        $('#quotationPartLineModal' + this.selector()).modal('show');
    }

    public selector(): string {
        return ('-' + this.type() + '-' + this.index()).replace(' ', '');
    }
}

export class AssignmentModel {
    fromLanguage: KnockoutObservable<Language>;
    toLanguage: KnockoutObservable<Language>;
    startDate: KnockoutObservable<moment.Moment>;
    endDate: KnockoutObservable<moment.Moment>;
    qplPrice: KnockoutObservable<number>;
    leadTime: KnockoutObservable<number>;
    selectedDeliverable: KnockoutObservable<string>;
    startTimeIsEstimate: KnockoutObservable<boolean>;

    deliverableAmount: KnockoutObservable<number>;
    deliverable: KnockoutComputed<string>;
    deliverables: Deliverable[];

    constructor(
        fromLanguage: Language,
        toLanguage: Language,
        deliverables: Deliverable[],
        startDate?: moment.Moment,
        endDate?: moment.Moment,
        selectedDeliverable?: string,
        price?: number,
        startTimeIsEstimate?: boolean,
        leadTime?: number,
        deliverableAmount?: number
    ) {
        this.deliverables = deliverables;

        this.fromLanguage = ko.observable<Language>(fromLanguage);
        this.toLanguage = ko.observable<Language>(toLanguage);
        this.startDate = ko.observable<moment.Moment>(startDate);
        this.endDate = ko.observable<moment.Moment>(endDate);
        this.qplPrice = ko.observable<number>(price);
        this.leadTime = ko.observable<number>(leadTime);
        this.selectedDeliverable = ko.observable<string>(selectedDeliverable);
        this.startTimeIsEstimate = ko.observable<boolean>(startTimeIsEstimate);
        this.deliverableAmount = ko.observable<number>(deliverableAmount || 1);

        this.deliverable = ko.pureComputed(() => {
            let deliverable = this.deliverables.find((d) => d.id === this.selectedDeliverable());

            return deliverable
                ? deliverable.label
                : '-';
        }, this);
    }

    public async updatePrice(
        amount: number | null,
        type: number): Promise<void> {
        if (!amount || amount <= 0) {
            return;
        }

        const body = {
            from: this.fromLanguage().value,
            to: this.toLanguage().value,
            type,
            amount
        };

        const response = await fetch('/Quotation/Price', {
            credentials: 'include',
            body: JSON.stringify(body),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const json = await response.json();

        this.qplPrice(json.data);
    }

}